import {Action} from 'redux'
import {ShareholderRecordModel} from '../Model'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export interface IShareholderLookupState {
  data?: {
    record?: ShareholderRecordModel[]
    meta?: {[key: string]: number}
  }
  loading?: boolean
}

const initialState: IShareholderLookupState = {
  data: {record: [], meta: {}},
  loading: false,
}

export const reducer = (
  state: IShareholderLookupState = initialState,
  action: ActionWithPayload<IShareholderLookupState['data']>
) => {
  switch (action.type) {
    case actionTypes.GET_SHAREHOLDER_RECORDS_START:
      return {...state, loading: true}
    case actionTypes.GET_SHAREHOLDER_RECORDS_SUCCESS:
      return {...state, data: action.payload, loading: false}
    case actionTypes.GET_SHAREHOLDER_RECORDS_FINISH:
      return {...state, loading: false}
    default:
      return state
  }
}
